var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-progress',{attrs:{"type":"default","value":_vm.getProgress(),"label":_vm.$t('votedplayers')}}),_c('div',[(_vm.nonVotedNames.length > 0)?_c('span',[_c('font-awesome-icon',{attrs:{"icon":"clock"}}),_vm._v(" "+_vm._s(_vm.nonVotedNames))],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }